import React, {useMemo} from 'react';
import SPBreadcrumb from 'components/base/SPBreadcrumb';
import SPModuleTitle from "components/base/SPModuleTitle";
import SPTuwen from "components/base/SPTuwen";
import SPSearchForm from "components/actives/didi-selection/search-form";
import SPTable from "components/actives/didi-selection/table";
import 'components/actives/didi-selection/table/index.css'
import SPCancelDrawer from "components/product-price/cancel-rule-template/drawer";
import SPServiceDrawer from 'components/product-price/service-policy-template/drawer';
import SPValueAddDrawer from 'components/product-price/value-added-price/drawer';
import emiter, {_EVENTS} from "../../../events";
interface IPageProps {
	enums?: any;
	permission?: any;
}

const SPPage: React.FC<IPageProps> = props => {
	const { enums, permission } = props;

  const pics = useMemo(() => {
    const list = enums?.f_didijingxuan_introduc_pics || []
    return list.map((item: any) => item.value)
  }, [enums])

  const text = useMemo(() => {
    const list = enums?.f_didijingxuan_introduc_text || []
    return list.map((item: any) => item.value).join('')
  }, [enums])

  const closedHookFn = () => {
    emiter.emit(_EVENTS.ACTIVES.DIDI_SECTION.SEARCH, {});
  }

  return (
    <div className="didi-section">
      <SPBreadcrumb title={'滴滴精选'}></SPBreadcrumb>
      <div style={{marginTop: '16px'}}>
        <SPModuleTitle title='栏目介绍'></SPModuleTitle>
      </div>
      <SPTuwen pics={pics} text={text}/>
      <div style={{marginTop: '24px'}}>
        <SPModuleTitle title='商品准入情况'></SPModuleTitle>
      </div>
      <div style={{marginTop: '16px'}}>
        <SPSearchForm enums={enums}></SPSearchForm>
      </div>
      <div style={{marginTop: '16px'}}>
        <SPTable></SPTable>
      </div>
      <SPCancelDrawer closedHook={closedHookFn} enums={enums}/>
      <SPServiceDrawer closedHook={closedHookFn} enums={enums}/>
      <SPValueAddDrawer closedHook={closedHookFn} enums={enums}/>
    </div>
  );
};

export default SPPage;
